import { createSlice } from "@reduxjs/toolkit"
import { tableTypes } from "../../pages/PnlReporting/constants"
import { PnlReportingState } from "../../pages/PnlReporting/types"

const initialState: PnlReportingState = {
  // common
  tableType: tableTypes.REPORTING,
  //reporting
  years: {
    data: [],
    selected: null,
  },
  months: [],

  pnlReportingClasses: [],
  pnlReportingSelectedClass: null,
  pnlReportinigTableData: [],
  reportingAggregations: [],
  reportingScrollTop: 0,

  // reporting detail
  selectedLineItem: null,
  reportDetail: [],
  reportDetailAggregate: [],

  // transaction state
  transactionData: [],
  selectedTransaction: {},
}

const pnlReportingSlice = createSlice({
  name: "pnl-reporting",
  initialState,
  reducers: {
    setPNLYears: (state, action) => {
      state.years.data = action.payload
    },
    setSelectedYear: (state, action) => {
      state.years.selected = action.payload
    },
    setPnlReportingMonths: (state, action) => {
      state.months = action.payload
    },
    setPNLClasses: (state, action) => {
      state.pnlReportingClasses = action.payload
    },
    setPnlReportingSelectedClasses: (state, action) => {
      const nextId = action.payload?.class_id
      const prevId = state.pnlReportingSelectedClass?.class_id
      if (prevId !== nextId) {
        if (state.tableType === tableTypes.REPORTING) {
          state.selectedLineItem = null
          state.reportingScrollTop = 0
          state.selectedTransaction = {}
          state.reportDetail = []
          state.reportDetailAggregate = []
        } else {
          if (state.tableType === tableTypes.SUBDETAIL) {
            state.tableType = tableTypes.DETAIL
          }
          state.selectedTransaction = {}
          state.reportDetail = []
          state.reportDetailAggregate = []
        }
      }
      state.pnlReportingSelectedClass = action.payload
    },
    setSelectedTransactionClass: (state, action) => {
      state.selectedTransaction = action.payload
    },
    setReportingData: (state, action) => {
      state.reportDetail = action.payload?.data || []
      state.reportDetailAggregate = action.payload?.agg || []
    },
    setSelectedLineItem: (state, action) => {
      state.selectedLineItem = action.payload
    },
    setTableType: (state, action) => {
      state.tableType = action.payload
    },
    setTransactionData: (state, action) => {
      state.transactionData = action.payload
    },
    setPnlReportinigTableData: (state, action) => {
      state.reportingAggregations = action.payload?.agg || []
      state.pnlReportinigTableData = action.payload?.data || []
      state.reportingScrollTop = 0
    },
    setReportingScrollTop: (state, action) => {
      state.reportingScrollTop = action.payload
    },
  },
})

export default pnlReportingSlice.reducer

export const {
  setPNLYears,
  setSelectedYear,
  setPNLClasses,
  setPnlReportingMonths,
  setPnlReportingSelectedClasses,
  setReportingData,
  setTableType,
  setSelectedLineItem,
  setSelectedTransactionClass,
  setTransactionData,
  setPnlReportinigTableData,
  setReportingScrollTop,
} = pnlReportingSlice.actions
